import React from 'react';
import PropTypes from 'prop-types';

import SearchInput from 'components/SearchInput';
import Select from 'components/Select';

const SearchWithFilters = ({
  onChangeFilter,
  onChangeInput,
  searchTerm,
  searchFilter,
  options,
  placeholder,
  hasFilters,
  onSearch,
  isClearable,
  onClearInput,
}) => {
  const _onSearch = (e) => {
    e.preventDefault();
    onSearch();
  };

  return (
    <form
      onSubmit={_onSearch}
      data-testid="search-with-filters"
      className={`card mb-5 flex ${
        hasFilters ? 'flex-col md:flex-row flex-auto' : 'flex-row flex-auto'
      } items-end md:items-center overflow-visible z-20`}
    >
      <SearchInput
        className={`h-10 text-javelin-gray-dark ${
          hasFilters ? 'md:flex-1' : 'flex-1'
        } w-full md:w-auto flex-shrink-0`}
        onChange={onChangeInput}
        value={searchTerm}
        placeholder={placeholder}
        onClear={onClearInput}
      />
      <div
        className={`flex items-center ml-3 ${
          hasFilters ? 'mt-3 md:mt-0' : 'mt-0'
        }`}
      >
        {hasFilters && (
          <>
            <span className="flex-shrink-0 font-bold text-sm mr-3">
              Search in
            </span>
            <Select
              options={options}
              onChange={onChangeFilter}
              isSearchable={false}
              placeholder="Select an option"
              value={searchFilter}
              className="search-filter-select"
              isClearable={isClearable}
            />
          </>
        )}
        <button
          className="btn btn-blue px-5 rounded font-normal text-sm h-10 w-24 ml-3"
          disabled={
            hasFilters
              ? !(searchFilter && searchTerm.length)
              : !searchTerm.length
          }
          type="submit"
        >
          Search
        </button>
      </div>
    </form>
  );
};

SearchWithFilters.propTypes = {
  onClearInput: PropTypes.func,
  onChangeFilter: PropTypes.func,
  onChangeInput: PropTypes.func,
  searchTerm: PropTypes.string,
  searchFilter: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({})),
  placeholder: PropTypes.string,
  hasFilters: PropTypes.bool,
  onSearch: PropTypes.func,
  isClearable: PropTypes.bool,
};
SearchWithFilters.defaultProps = {
  placeholder: 'Search transactions',
  searchTerm: '',
  hasFilters: false,
  isClearable: false,
};

export default SearchWithFilters;
